export function formatNumber(number, decimalPlaces, lang) {
    if(number === 0)
    return number;

    if (isNaN(number) || number === "" || number === null) {
        return "";
    }

    const formattedNumber = new Intl.NumberFormat(lang, {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces
    }).format(number);

    return formattedNumber;
}